import React, {memo} from 'react';
import {TextField} from "@mui/material";

const TextBox = (props) => {
    return <TextField {...props} />

}
export default memo(TextBox);